import { Skeleton } from '@synoptic/ui-kit/skeleton/skeleton.js';
import {
  bannerBody,
  bannerContainer,
  bannerContent,
  bannerImgContainer,
  bannerInfo,
  bannerTitle,
  bannerTopContainer,
} from './tournament-banner.css';

export const TournamentBannerSkeleton: React.FC = () => {
  return (
    <div className={bannerTopContainer}>
      <div className={bannerContainer}>
        <div className={bannerImgContainer}></div>

        <div className={bannerContent}>
          <div className={bannerInfo}>
            <Skeleton width={185} height={21} />

            <div className={bannerTitle}>
              <Skeleton width={'100%'} height={56} />
            </div>
            <div className={bannerBody}></div>
          </div>
        </div>
      </div>
    </div>
  );
};
